import React from "react";
import { Sparkles, Heart, Microscope, ShieldCheck } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function NossaMissao() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const values = [{
    icon: Microscope,
    title: "Ciência & Precisão",
    text: "Protocolos baseados em evidências e tecnologia de ponta."
  }, {
    icon: Heart,
    title: "Cuidado Humanizado",
    text: "Acolhimento e foco total no bem-estar feminino."
  }, {
    icon: ShieldCheck,
    title: "Transparência",
    text: "Diagnósticos claros e resultados reais, sem promessas vazias."
  }];
  return <section id="nossa-missão" ref={ref} className="bg-card py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary/20 to-transparent opacity-50" />
      
      <div className="container mx-auto px-6 max-w-4xl relative z-10">
        
        {}
        <div className={cn("text-center transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <span className="text-primary font-sans text-sm tracking-[0.2em] uppercase font-semibold mb-4 block">
            Nossa Missão
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground leading-tight mb-8">
            "Unir a precisão da <span className="italic text-primary">ciência tricólogica</span> ao cuidado humano para restaurar a saúde capilar e a autoestima de cada mulher."
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-light max-w-2xl mx-auto leading-relaxed">
            Na Dil Saúde Capilar, acreditamos que cada fio conta uma história. 
            Nosso compromisso é oferecer diagnósticos detalhados e tratamentos personalizados 
            que vão além da estética, promovendo saúde e bem-estar duradouros.
          </p>
        </div>

        {}
        <div className={cn("relative my-20 transition-all duration-1000 delay-300 ease-out", isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95")}>
          <Separator className="bg-border/60" />
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-card px-4 text-primary">
            <Sparkles className="size-6 stroke-[1.5]" />
          </div>
        </div>

        {}
        <div className={cn("text-center transition-all duration-1000 delay-500 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <span className="text-primary font-sans text-sm tracking-[0.2em] uppercase font-semibold mb-10 block">
            Nossos Valores
          </span>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
            {values.map((value, i) => <div key={i} data-index={i} className="flex flex-col items-center group">
                <div className="mb-5 p-4 rounded-full bg-primary/5 text-primary group-hover:bg-primary/10 transition-colors duration-300">
                  <value.icon className="size-8 stroke-[1.2]" />
                </div>
                <h3 className="font-serif text-2xl text-foreground mb-3">
                  {value.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {value.text}
                </p>
              </div>)}
          </div>
        </div>

      </div>
    </section>;
}